import React, { FC } from 'react';
import { ReadyDesignsView } from '../components';

export const DesignsPage: FC = () => {
  return <ReadyDesignsView />;
};
